import { Button, Grid, Typography } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
const centerAlignStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}

export const SurveyEnd = ({ replay }: any) => {
  return (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={12} sx={{ ...centerAlignStyle }}>
          <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 60, marginBottom: '30px' }} color='primary' />
          <Typography color='primary' sx={{ fontSize: '40px', fontWeight: 600 }} align="center">
            Thanks for submitting your feedback!
          </Typography>
          <Typography color='primary' sx={{ fontSize: '24px', fontWeight: 400 }} align="center">
            Please close the browser window to exit the game.
          </Typography>
          <Button onClick={replay} sx={{ marginTop: '30px', borderRadius: '3rem', textTransform: 'capitalize', padding: '0.625rem 1.25rem' }} variant="contained" >Replay</Button>
        </Grid>
      </Grid>
    </Grid>
  )
}